import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";

import { CoachAvatar, fullName, Rail, SectionHeader, DISCOVERY_CARD_SX } from "/imports/ui/components/discovery";

// Two rows of three on mobile; the rest are one tap away under "View all".
const MOBILE_LIMIT = 6;
const DESKTOP_LIMIT = 10;

function CoachesRail({ coaches, go }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const viewAll = () => go("coaches");

  if (isMobile) {
    return (
      <Box sx={{ mb: 4 }}>
        <SectionHeader title="Our coaches" onViewAll={viewAll} />
        <Grid container spacing={1.5}>
          {coaches.slice(0, MOBILE_LIMIT).map((coach) => (
            <Grid item xs={4} key={coach._id}>
              <Box sx={{ ...DISCOVERY_CARD_SX, height: "100%", overflow: "hidden" }}>
                <CardActionArea
                  onClick={() => go(`coaches/${coach._id}`)}
                  sx={{ p: 1.25, height: "100%", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}
                >
                  <CoachAvatar trainer={coach} size={52} />
                  <Typography
                    fontWeight={600}
                    sx={{
                      mt: 0.75,
                      width: "100%",
                      fontSize: "0.78rem",
                      lineHeight: 1.3,
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden"
                    }}
                  >
                    {fullName(coach)}
                  </Typography>
                </CardActionArea>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Rail title="Our coaches" onViewAll={viewAll}>
      {coaches.slice(0, DESKTOP_LIMIT).map((coach) => (
        <Box key={coach._id} sx={{ ...DISCOVERY_CARD_SX, width: "9.375rem", flexShrink: 0, overflow: "hidden" }}>
          <CardActionArea
            onClick={() => go(`coaches/${coach._id}`)}
            sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", height: "100%" }}
          >
            <CoachAvatar trainer={coach} size={64} />
            <Typography fontWeight={600} sx={{ mt: 1.25, fontSize: "0.9rem" }} noWrap>
              {fullName(coach)}
            </Typography>
            {coach.title && (
              <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: "100%" }}>
                {coach.title}
              </Typography>
            )}
          </CardActionArea>
        </Box>
      ))}
    </Rail>
  );
}

export default CoachesRail;
